import {WlRange} from "./range.component";

export * from './range.component';
export default WlRange;

customElements.define('wl-range', WlRange);
